<script setup lang="ts">

</script>

<template>
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_2069_323)">
      <path d="M9.75 4.5L6 8.25L2.25 4.5" stroke="black" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_2069_323">
        <rect width="12" height="12" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>

<style scoped lang="scss">

</style>
